import React from 'react'
import { useAuth } from '../hooks/use-auth';
import {removeUser} from '../store/slices/userSlice'
import {Redirect} from 'react-router-dom';
import {useDispatch} from 'react-redux'
import {NavLink} from 'react-router-dom'


export const Navbar = () => {
  const dispatch = useDispatch();

  const {isAuth, email} = useAuth();
  const isEmail = email === 'admin@gmail.com';

  return isAuth ? (
      <div>
          
<nav className="navbar navbar-dark navbar-expand-lg bg-primary ps-5">
    <div className="navbar-brand ps-4">
      Пункт приема
    </div>

    <ul className="navbar-nav">
      <li className="nav-item">
        <NavLink
          className="nav-link"
          to="/"
          exact
        >
          Админ. панель
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          className="nav-link"
          to="/metal"
        >
          Металл
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          className="nav-link"
          to="/lom"
        >
          Лом
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          className="nav-link"
          to="/about"
        >
          Информация
        </NavLink>
      </li>
      <li className="nav-item">
      { isEmail ? 
      <NavLink
      className="nav-link"
      to="/register">
        Добавить пользователя
      </NavLink>
      :
      <div></div>
      }
      </li>
      <li className="nav-item" style={{position: 'absolute', right: 50 + 'px'}}>
        <NavLink
          className="nav-link"
          to="/"
        >
          {email}
        </NavLink>
      </li>

      <button type="submit" class="btn btn-primary" style={{position: 'absolute', right: 50 + 'px'}}
  onClick={()=> dispatch(removeUser())}>Выход</button>
    </ul>
    
  </nav>
  
      
      </div>
  ) : (
      <Redirect to="/login" />
  )
}



